import { useTranslation } from 'react-i18next';
import { missionsResponseSchema } from '@unit/shared';
import { useApi } from '../../lib/useApi.js';

const input = 'rounded-lg border border-slate-300 px-2.5 py-1.5 text-sm';

/**
 * "Standing gear, or for a mission?" on the issue screens (§2.5 "Missions").
 * Only missions that are not closed are offered: gear cannot be drawn for an
 * operation that is over. Picking one also proposes the mission's end as the
 * due date, which the issuer may still change.
 */
export function MissionSelect({
  value,
  onChange,
  testId = 'mission-select',
}: {
  value: string;
  onChange: (missionId: string, endAt: string | null) => void;
  testId?: string;
}) {
  const { t } = useTranslation();
  const missions = useApi('/missions', missionsResponseSchema);
  const open = missions.kind === 'ready' ? missions.data.missions.filter((m) => m.status !== 'closed') : [];

  return (
    <label className="text-xs text-slate-600">
      {t('issue.mission')}
      <select
        className={`${input} mt-1 block`}
        value={value}
        onChange={(e) => onChange(e.target.value, open.find((m) => m.id === e.target.value)?.endAt ?? null)}
        data-testid={testId}
      >
        <option value="">{t('issue.standingGear')}</option>
        {open.map((m) => (
          <option key={m.id} value={m.id}>
            {m.name}
          </option>
        ))}
      </select>
    </label>
  );
}
